import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import MTD from "@ss/mtd-vue";
import "@bfe/mtd-theme-582/index.css";
import "./styles/index.css";

import store from "./store/index";

import { redirectLoginUrl } from "./utils/epassport";

import arLocale from "element-ui/lib/locale/lang/ar";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";

// 接入芥末基座的 sdk -- 必须要有
import jiemoAppport from "@osgfe/jiemo-appport";
import "@osgfe/jiemo-appport/dist/style.css";

import { i18nPlugin, getCacheLocale } from "@sailor/i18n-vue";
import ChainedBackend from "i18next-chained-backend";
import OpenAPIBackend from "@sailor/i18n-web-openapi-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import resources from "./assets/locales/resources";


window.__requestErrorCallback = (e, req) => {
  if (!e) return;
  console.error(`Interface request failed[${req.url}]: ${e}`);
  const code = e.type === "data" ? +e.data.code : +e.code;
  if (code === 5) {
    ElementUI.Message.error(
      (e && e.message) || "Login abnormal, please log in again"
    );
    clearTimeout(window.__epReloginTimer);
    window.__epReloginTimer = setTimeout(() => {
      redirectLoginUrl();
    }, 2000);
  } else {
    ElementUI.Message.error(
      (e && (e.msg || e.message || e.toString())) ||
        "System request exception"
    );
  }
};


const localeMap = {
  zh: zhLocale,
  en: enLocale,
  ar: arLocale,
};

export default function (App) {
  const currentLocaleStr = getCacheLocale() || "en";

  Vue.use(ElementUI, { locale: localeMap[currentLocaleStr] });
  Vue.use(jiemoAppport, { locale: localeMap[currentLocaleStr] });
  Vue.use(MTD);
  Vue.use(i18nPlugin, (i18nClient) => {
    i18nClient.use(ChainedBackend).init({
      fallbackLng: "en",
      // 配置backend
      backend: {
        backends: [OpenAPIBackend, resourcesToBackend(resources)],
        // 这里配置一下所使用的projectId和namespaceId
        backendOptions: [
          {
            env: process.env.NODE_ENV === "production" ? "prod" : "test",
            namespaces: [
              {
                projectId: 43,
                apiKey: "5960afab14104e319ab1a7db5057e908",
                namespaceId: "igkekhb84x",
              },
            ],
          },
        ],
      },
    });
  });
  // eslint-disable-next-line no-new
  new Vue({
    el: "#app",
    store,
    render(h) {
      return h(App);
    },
  });

  window.Vue = Vue;
}
